<template>
<div>
  <v-layout row>
    <div>
      <confirm ref="confirm"></confirm>
      <loader v-model=statusval.loading></loader>
      <arksnackbar v-model="statusval"></arksnackbar>
    </div>

    <v-flex xs12 sm12>
      <v-card>
        <v-btn fab small color="cyan accent-2" bottom left absolute @click="onInsertItem()">
          <v-icon>add</v-icon>
        </v-btn>
      </v-card>

      <v-data-table :headers="tableheaders" :items="tableitems" hide-actions class="elevation-1">

        <template slot="items" slot-scope="props">
          <tr>
            <slot v-bind:item="props.item">
              <td v-for="tableheader in tableheaders" :key="tableheader.id" v-if="tableheader.value!='islemsutunu'">
                <template v-if="tableheader.value2!=undefined">
                  {{ props.item[tableheader.value][tableheader.value2]}}
                </template>
                <template v-else>
                  {{props.item[tableheader.value]}}
                </template>
              </td>
            </slot>

            <td class="justify-center layout px-0">
              <v-btn icon class="mx-0" @click="onEditItem(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click="onDeleteItem(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>

    </v-flex>

    <customdialog v-model="dialog" maxWidth=500px :title="dialogTitle()">
      <slot name="dialogmain" v-bind:item="val"></slot>
      <template slot="btn">
        <v-btn color="primary" flat @click="dialogOk">{{$t("save_button")}}</v-btn>
      </template>
    </customdialog>

    <!--
    <v-dialog v-model="dialog" scrollable max-width=500px>
      <v-card>
        <v-card-title>
          <h3 v-if="dialogStatus=='edit'">Kayıt Düzenle</h3>
          <h3 v-else-if="dialogStatus=='insert'">Yeni Kayıt</h3>
        </v-card-title>
        <v-card-text>
          <slot name="dialogmain" v-bind:item="val"></slot>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="dialogOk">{{$t("save_button")}}</v-btn>
          <v-btn color="primary" flat @click.stop="dialog=false">iptal</v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    -->

  </v-layout>

</div>
</template>

<script>
//import rez from "../../rezervasyon";
import confirm from "@/components/app/coper/comp/confirm.vue";
import loader from "@/components/app/coper/comp/loader.vue";
import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";
import customdialog from "@/components/app/coper/comp/customdialog.vue";

import tool from "../tools";

export default {
  props: ["tableitems", "tableheaders", "title", "item", "status"],
  data() {
    return {
      dialog: false,
      dialogStatus: null,
      fitem: null
    }
  },

  components: {
    confirm,
    loader,
    arksnackbar,
    customdialog
  },

  computed: {
    val: {
      get: function () {
        if (this.fitem == null) return this.item;
        else return this.fitem;
      },
      set: function (newValue) {
        this.fitem = Object.assign({}, newValue);
      }
    },
    statusval: {
      get: function () {
        if (this.status == null) {
          return tool.NewSatatus();
        } else {
          return this.status;
        }
      }
    }
  },

  methods: {
    onEditItem: onEditItem,
    onInsertItem: onInsertItem,
    onDeleteItem: onDeleteItem,
    dialogOk: dialogOk,
    dialogTitle(){
      if (this.dialogStatus=="edit")
        return this.$t('Edit-Record')
      else if (this.dialogStatus=='insert')
        return this.$t('New-Record')
      else
        return ""
    }
  }
}

function dialogOk() {
  this.dialog = false;

  if (this.dialogStatus == "edit") {
    this.$emit("edititem", this.val);
  } else if (this.dialogStatus == "insert") {
    this.$emit("insertitem", this.val);
  }
}

function onEditItem(v) {
  this.dialogStatus = "edit";

  this.val = JSON.parse(JSON.stringify(v));

  this.dialog = true;
}

function onInsertItem() {
  this.dialogStatus = "insert";
  //this.val = Object.assign({}, this.item);
  this.val = JSON.parse(JSON.stringify(this.item));


  this.dialog = true;
}

function onDeleteItem(val1) {

  this.$refs.confirm
    .open("Kayıt Sil", this.$t('Delete-the-records'), {
      color: "red",
      message: this.$t('approve-record-deletion')
    })
    .then(confirm => {
      if (confirm == true) {
        this.$emit("deleteitem", val1);
      }
    });
}
</script>
